import { createRoute, useNavigate, Link } from '@tanstack/react-router'
import { RiArrowLeftLine } from '@remixicon/react'
import { authLayoutRoute } from './_auth'
import { PlaylistForm } from '@/components/playlist'
import { api, queryClient } from '@/lib/api'

export const createPlaylistRoute = createRoute({
	getParentRoute: () => authLayoutRoute,
	path: '/playlists/create',
	component: CreatePlaylistPage,
})

function CreatePlaylistPage() {
	const navigate = useNavigate()

	const handleSubmit = async (values: { name: string; icon: string; color: string; spotifyPlaylistId: string }) => {
		const response = await api.api.playlists.post({
			name: values.name,
			icon: values.icon || undefined,
			color: values.color || undefined,
			spotifyPlaylistId: values.spotifyPlaylistId || undefined,
		})

		if (response.error) {
			throw new Error('Failed to create playlist')
		}

		await queryClient.invalidateQueries({ queryKey: ['playlists'] })
		navigate({ to: '/' })
	}

	return (
		<main className="relative flex-1">
			{/* Atmospheric gradient */}
			<div
				className="pointer-events-none absolute inset-x-0 top-0 h-72"
				style={{
					background: `radial-gradient(ellipse 80% 50% at 50% 0%, oklch(0.77 0.16 70 / 6%) 0%, transparent 100%)`,
				}}
			/>

			<div className="relative px-5 py-6">
				<div className="mx-auto max-w-md space-y-6">
					<div className="space-y-4">
						<Link
							to="/"
							className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
						>
							<RiArrowLeftLine className="size-3.5" />
							Back to playlists
						</Link>
						<div className="space-y-2">
							<h2 className="font-serif text-2xl font-semibold tracking-tight">
								New Playlist
							</h2>
							<p className="text-sm text-muted-foreground">
								Create a new playlist to organize your music.
							</p>
						</div>
					</div>

					<PlaylistForm onSubmit={handleSubmit} />
				</div>
			</div>
		</main>
	)
}
